import { HTMLMotionProps, motion } from 'framer-motion';
import { FC, PropsWithChildren } from 'react';
import { Outlet } from 'react-router';
import { Link } from 'react-router-dom';

import HeaderLogo from '@/components/decoration/HeaderLogo';
import { twMerge } from 'tailwind-merge';
import { HeaderNavigation } from '../header/Header';
import RightHandSideNavSection from '../header/RightHandSideNavSection';

export const Main: FC = () => {
  return (
    <main className="flex h-screen w-full flex-col">
      <header className="border-secondary-std border-b">
        <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 py-3 sm:px-8">
          <motion.div layoutId="navigation" className="flex items-center gap-5">
            <Link to="/">
              <HeaderLogo />
            </Link>
            <HeaderNavigation />
          </motion.div>
          <RightHandSideNavSection />
        </div>
      </header>
      <div className="flex flex-1 flex-col bg-gradient-to-b from-[#B4EEFF33] to-[#FFEFDD33] overflow-y-scroll">
        <Outlet />
      </div>
    </main>
  );
};

interface ContainerProps extends HTMLMotionProps<'div'> {
  containerClassName?: string;
  animate?: 'pop' | 'fade';
}

export const Container: FC<PropsWithChildren<ContainerProps>> = ({
  className,
  containerClassName,
  children,
  animate,
  ...props
}) => {
  return (
    <motion.div className={twMerge('w-full', containerClassName)}>
      <motion.div
        {...props}
        initial={animate && { transform: animate === 'pop' ? 'translateY(40px)' : undefined, opacity: 0 }}
        animate={{ transform: 'translateY(0px)', opacity: 1 }}
        className={twMerge('mx-auto w-full max-w-7xl px-4 sm:px-8', className)}
      >
        {children}
      </motion.div>
    </motion.div>
  );
};
